import React from 'react';
import ExternalLanding from "../ExternalLanding";
import useHubSpotUTMQueryParams from "../../hooks/useHubSpotUTMQueryParams";
import {externalLinks} from "../../requests/external-endpoints";

const GmsLanding = () => {
  const searchParams = useHubSpotUTMQueryParams();
  const constructedUrl = `${externalLinks.gmsLanding}?${searchParams.toString()}`;
  return <ExternalLanding url={constructedUrl} />
}

export default GmsLanding;